import { render, staticRenderFns } from "./AppTranslateAI.vue?vue&type=template&id=8d229e98&scoped=true"
import script from "./AppTranslateAI.vue?vue&type=script&lang=js"
export * from "./AppTranslateAI.vue?vue&type=script&lang=js"
import style0 from "./AppTranslateAI.vue?vue&type=style&index=0&id=8d229e98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d229e98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/.pnpm/vuetify-loader@1.7.3_uhb5aaqqgawn4pxsnzso5z623i/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
